export default __webpack_public_path__ + "static/portfolio-mas-9-b44585f9b98998ea63d2125b4ecec355.jpg";